;(function(window, APP, Backbone, Marionette, $, _, PermissionManager, AdditionalRegistrationManager) {
	'use strict';

	var Model = APP.module('Model');
	var View = APP.module('View');

	APP.on('start', function() {

		PermissionManager.onPermissionType({
			/*Only for logged in users */
			1: function(object) {

				if (!APP.getJStorage('session_id')) {
					APP.setJStorage('backTo', window.location.hash);
					Backbone.history.navigate('/', {trigger: true});
					return false;
				}
				else {

					if (object.skip_registration_manager) {
						return true;
					}
					return AdditionalRegistrationManager
						.setModel(Model.RegistrationFormBuild)
						.isUserRegisteredForGames({path_name: object.path_name});
				}
			},
			/*Only for non logged in users */
			2: function(object) {
				if (APP.getJStorage('session_id')) {

					var user_desired_url = APP.getJStorage('user_desired_url');

					if (user_desired_url === '#login' || user_desired_url === '#logout') {
						user_desired_url = false;
					}

					Backbone.history.navigate(user_desired_url ? user_desired_url : object.redirect_to, {trigger: true});
					return false;
				}

				return true;
			},
			/*For "Coming soon" pages*/
			3: function(object) {
				APP.vent.trigger('mobile_menu:close');
				var message = object.message ? object.message : 'Coming soon!',
					title   = object.title ? object.title : false
				;

				if(CONFIG.IS_MULTY_LANG){
					message = i18next.t(message);
					title = title ? i18next.t(title) : false;
				}

				if (title) {
					APP.vent.trigger('popup:message:show', message, title);
				}
				else {
					APP.vent.trigger('popup:message:show', message);
				}

				if (object.redirect_to) {
					Backbone.history.navigate(object.redirect_to, {trigger: true});
				}
				return false;
			},
			/* Wipe Pseudo SID if exists or check login */
			4: function(options) {
				if (APP.module('instance').user.hasPseudoSID()) {

					APP.module('instance').user.deletePseudoSID();
					return true;

				}

				return PermissionManager.callbacks[2].apply(null, arguments);

			},
			/* Check user or generate pseudo SID */
			5: function(options) {
				//console.warn(Boolean(APP.module('instance').user.get('id')));

				if (!Boolean(APP.module('instance').user.get('id'))) {

					APP.module('instance').user.setPseudoSID();

					return true;

				}
				else {

					return PermissionManager.callbacks[1].apply(null, arguments);
				}

			},
			/*Offseason Check*/
			6: function(options) {
				var is_offseason_or_prelaunch = CONFIG.OFF_SEASON || CONFIG.IS_PRELAUNCH;

				if (!is_offseason_or_prelaunch && options.redirect_to) {

					Backbone.history.navigate(options.redirect_to, {trigger: true});
				}
				return CONFIG.OFF_SEASON || CONFIG.IS_PRELAUNCH;
			},
			/*Can enter to page without register for game*/
			7: function(object) {

				if (!APP.getJStorage('session_id')) {
					APP.setJStorage('backTo', window.location.hash);
					Backbone.history.navigate('/', {trigger: true});
					return false;
				}

				return true;
			},
			/*Check register for game page*/
			8: function(object) {
				let permission_check = PermissionManager.callbacks[1](object);
				console.log(331331, permission_check);

				if (permission_check) {
					var user                = APP.module('instance').user,
						registration_object = new Model.RegistrationFormBuild().toJSON(),
						supported_games     = registration_object.games_supported;

					console.log(332332, user);
					console.log(334334, registration_object);
					console.log(335335, supported_games);

					return supported_games.length && !Boolean(~user.get('playing_games').indexOf(supported_games[0])); 
				}

				return permission_check;
			}
		});

	});
}(window, APP, Backbone, Marionette, $, _, PermissionManager, AdditionalRegistrationManager));
